<!--
긴급입고정보 컴포넌트
------------------------------------
-->
<template>
    <div class="uk-flex-top" uk-modal esc-close="false" bg-close="false">
        <div class="uk-modal-dialog uk-margin-auto-vertical uk-width-xxlarge">

            <div class="uk-modal-header uk-text-large uk-text-danger">
                긴급입고사유
            </div>


            <div class="uk-modal-body uk-padding-small uk-text-large">
                <div v-nl2br="reason">
                </div>

            </div>


            <div class="uk-modal-footer uk-text-right">
                <button
                    type="button"
                    class="uk-button uk-button-primary uk-button-large uk-modal-close"
                >
                    <i class="material-icons">check</i>
                    확인
                </button>
            </div>

        </div>
    </div>
</template>

<script>
    export default {
        components: {
        },
        props: {
            // 상품ID
            urgentShipIn: Object,
        },
        data: function () {
            return {
            };
        },
        computed: {
            /**
             * 사유
             * @return string
             **/
            reason() {
                if (this.urgentShipIn) {
                    return this.urgentShipIn.urgent_reason;
                }
                return null;
            }
        },
        methods: {


            /**
             * 창 띄우기
             */
            show() {
                // 폼 띄우기
                UIkit.modal(this.$el).show();
            },

        },
    }
</script>

<style lang="scss" scoped>

</style>